import MeetingHandler from "@/bussiness/MeetingHandler";
import recordStore from "@/store/record.store";
import summarySrcStore from "@/store/summarySrc.store";
import fridayReporter from "./friday";
import timingStore from "@/store/timing.store";
import { RuningInLink } from "@/constants";
import { message } from "antd";

export async function handleStartRecording(errorCb?: () => void) {
  const isWindows = navigator.platform.indexOf("Win") !== -1;

  fridayReporter.pushData({
    eventCode: "HomePage_StartRecord",
  });
  if (!isWindows && RuningInLink) {
    console.log("申请位置权限然后开始录制");
    await MeetingHandler.requestLocation();
    setTimeout(async () => {
      // 获取位置权限
      const check = await MeetingHandler.checkLocation();
      if (!check) {
        message.info("开启定位权限，体验一键连接附近设备");
        if (MeetingHandler.isRequested()) MeetingHandler.openLocationSetting();
        return;
      } else {
        console.log("已允许定位权限检测");
      }
      timingStore.getState().setStartLoading(true);
      const res = await MeetingHandler.startRecord();
      timingStore.getState().setStartLoading(false);
      if (res) window.navigate("/record");
      else errorCb?.();
    }, 200);
  } else {
    console.log("直接开始录制");
    timingStore.getState().setStartLoading(true);
    const res = await MeetingHandler.startRecord();
    timingStore.getState().setStartLoading(false);
    if (res) window.navigate("/record");
    else errorCb?.();
  }
}

export async function handleStopRecordingWithoutPermission() {
  MeetingHandler.stopRecordWithoutPermission();
  MeetingHandler.clearRecordStore();
} 

export async function handleStopRecording() {
  if (timingStore.getState().finishLoading) return;
  const recordTime = timingStore.getState().recordTime;
  fridayReporter.pushData({
    eventCode: "RecordPage_End",
    payload: {
      duration: Math.ceil(recordTime / 60)
    }
  });
  timingStore.getState().setFinishLoading(true);
  const success = await MeetingHandler.stopRecord();
  timingStore.getState().setFinishLoading(false);
  if (success) {
    const streamName = recordStore.getState().streamName;
    const streamId = streamName.split("/")[1];
    summarySrcStore.getState().generateTitle(false, streamName);
    window.navigate(`/summary?streamId=${streamId}`, { replace: true });
    MeetingHandler.clearRecordStore();
    message.success("记录保存成功");
  } else {
    console.log("结束录制失败, 请重试");
  }
}

export async function handlePauseRecording() {
  if (timingStore.getState().pauseOrResumeLoading) return;
  fridayReporter.pushData({
    eventCode: "RecordPage_Pause",
  });
  timingStore.getState().setPauseOrResumeLoading(true);
  await MeetingHandler.pauseRecord();
  timingStore.getState().setPauseOrResumeLoading(false);
}

export async function handleResumeRecording() {
  if (timingStore.getState().pauseOrResumeLoading) return;
  fridayReporter.pushData({
    eventCode: "RecordPage_Continue",
  });
  timingStore.getState().setPauseOrResumeLoading(true);
  await MeetingHandler.resumeRecord();
  timingStore.getState().setPauseOrResumeLoading(false);
}
